import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type MarkSharedAssetsDownloadedMutationVariables = Types.Exact<{
  input: Types.MarkSharedAssetsDownloadedInput;
}>;


export type MarkSharedAssetsDownloadedMutation = { __typename?: 'Mutation', markSharedAssetsDownloaded?: { __typename?: 'MarkSharedAssetsDownloadedPayload', successful?: boolean | null } | null };


export const MarkSharedAssetsDownloaded = /*#__PURE__*/ gql`
    mutation MarkSharedAssetsDownloaded($input: MarkSharedAssetsDownloadedInput!) {
  markSharedAssetsDownloaded(input: $input) {
    successful
  }
}
    ` as unknown as DocumentNode<MarkSharedAssetsDownloadedMutation, MarkSharedAssetsDownloadedMutationVariables>;

          

          export const useMarkSharedAssetsDownloadedMutation = (options?:MutationHookOptions<MarkSharedAssetsDownloadedMutation, MarkSharedAssetsDownloadedMutationVariables>) => useMutation(MarkSharedAssetsDownloaded, options);
          

          export type MarkSharedAssetsDownloadedMutationOptions = MutationHookOptions<MarkSharedAssetsDownloadedMutation, MarkSharedAssetsDownloadedMutationVariables>;

          

          export type MarkSharedAssetsDownloadedMutationResult = ReturnType<typeof useMarkSharedAssetsDownloadedMutation>[1];

          
